// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container__form-forum-thread .text__topic{color:#3b3e66;font-size:16px;font-weight:700}", ""]);
// Exports
module.exports = exports;
